import { format } from 'date-fns';

const fetchUserDetails = async (phone_number, dob, course) => {
  console.log('inside api call')
  const [day, month, year] = dob.split('/');
  const tmpDob = `${day}-${format(new Date(year, month - 1), 'MMM')}-${year}`;
  console.log(tmpDob);
  console.log(dob);
  const url = `https://go-gin-certificate-portal.onrender.com/userData/${phone_number}/${tmpDob}/${course}`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
};

export default fetchUserDetails;
